import { render, staticRenderFns } from "./IBSInbound_old.vue?vue&type=template&id=4fe4e97e&scoped=true"
import script from "./IBSInbound_old.vue?vue&type=script&lang=js"
export * from "./IBSInbound_old.vue?vue&type=script&lang=js"
import style0 from "./IBSInbound_old.vue?vue&type=style&index=0&id=4fe4e97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe4e97e",
  null
  
)

export default component.exports